import { FilePdf } from '@phosphor-icons/react';
import { getString } from '@/utils/chatUtils/chatDefaultUtils';
import { useChatDocumentViewer } from '@/hooks/useChatDocumentViewer';

type DocumentBlockBodyProps = {
  item?: Record<string, unknown>;
};

// Renders the source document as a button that opens it beside the chat. Used
// by the pinned "Started from" block when a chat began from a document.
export const DocumentBlockBody = ({ item }: DocumentBlockBodyProps) => {
  const { open: openSideViewer } = useChatDocumentViewer();
  const lectureId = getString(item?.lectureId);
  const fileName = getString(item?.fileName) || 'Document';

  if (!lectureId) {
    return (
      <div className="chat-ui_missing">
        This document is no longer available.
      </div>
    );
  }

  return (
    <div className="chat-ui_document">
      <button
        className="chat-ui_document-card"
        onClick={() => openSideViewer({ kind: 'lecture', lectureId })}
        type="button"
      >
        <FilePdf weight="fill" />
        <span className="chat-ui_document-name">{fileName}</span>
      </button>
    </div>
  );
};
